import { types } from 'mobx-state-tree';

const SiteType = {
  WEB_STORE: 'WEB_STORE',
  SHOPPING_CENTER: 'SHOPPING_CENTER',
  HOME_PAGE: 'HOME_PAGE'
};

export default SiteType;

export const SiteTypeType = types.enumeration('type', Object.values(SiteType));



// WEBPACK FOOTER //
// ./src/types/Site.js